import React, { useEffect } from "react";
import "../../../styles/progressbar.css";
import completedStep from "../../../assets/symbols/completed-step.svg";
import activeStep from "../../../assets/symbols/current-step.svg";
import disabledStep from "../../../assets/symbols/disabled-step.svg";

function ProgressBar({ currentStep }) {
  useEffect(() => {
    const firstLine = document.querySelector(".line-container .line");
    // Remove the animation from the first line if current step is 3
    if (firstLine && currentStep === 3) {
      firstLine.style.animation = "none";
    }
  }, [currentStep]);
  return (
    <div className="w-[86%] m-auto">
      <div className="progress-bar">
        <div className="step-container">
          <img
            src={completedStep}
            alt="Step 1"
            className={`step ${currentStep > 1 ? "completed" : ""}`}
            width={18}
            height={18}
          />
          <div className="text-left md:text-center">
            <p className="text-[#344054] text-[0.85rem] font-semibold mt-2 md:mt-0 ">
              My profile
            </p>
            <p className="text-[#475467] text-[0.85rem] w-full md:w-[85%] xl:w-full m-auto">
              Your profile is already updated
            </p>
          </div>
        </div>
        <div className="step-container">
          <img
            src={currentStep > 2 ? completedStep : activeStep}
            alt="Step 2"
            className={`step ${currentStep > 2 ? "completed" : "active"}`}
            width={18}
            height={18}
          />
          <div className="text-left md:text-center">
            <p
              className={`${
                currentStep === 2 ? " progress-text" : "text-[#344054]"
              } text-[0.85rem] font-semibold mt-2 md:mt-0`}
            >
              Candidate details
            </p>
            <p
              className={`${
                currentStep === 2 ? " progress-text" : "text-[#475467]"
              } text-[0.85rem] w-full md:w-[85%] xl:w-full m-auto`}
            >
              A few details about yourself
            </p>
          </div>
        </div>
        {/* <div className="step-container">
          <img
            src={currentStep === 3 ? activeStep : disabledStep}
            alt="Step 3"
            className={`step ${
              currentStep > 3 ? "completed" : currentStep === 3 ? "active" : ""
            }`}
            width={18}
            height={18}
          />
          <div className="text-left md:text-center">
            <p
              className={`${
                currentStep === 3 ? "progress-text" : "text-[#344054]"
              } text-[0.85rem] font-semibold mt-2 md:mt-0`}
            >
              Pricing plan
            </p>
            <p
              className={`${
                currentStep === 3 ? "progress-text" : "text-[#475467]"
              } text-[0.85rem] w-full md:w-[85%] xl:w-full m-auto`}
            >
              Get started with your suitable plan
            </p>
          </div>
        </div> */}
        <div className="line-container">
          <div className={`line ${currentStep >= 2 ? "filled" : ""}`}></div>
          <div className={`line ${currentStep >= 3 ? "filled" : ""}`}></div>
        </div>
        <div className="vertical-line-container">
          <div
            className={`vertical-line ${currentStep >= 2 ? "filled" : ""}`}
          ></div>
          <div
            className={`vertical-line ${currentStep >= 3 ? "filled" : ""}`}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default ProgressBar;
